import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as _Warning } from 'Images/warning-delete.svg';
import { slideIn, spinner } from 'Styles/effects';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ModalContent = styled.div`
  padding: 34px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  width: 505px;
  ${slideIn}
`;
ModalContent.displayName = 'ModalContent';

export const ModalTitle = styled.div`
  display: flex;
  margin-bottom: 21px;
`;
ModalTitle.displayName = 'ModalTitle';

export const Warning = styled(_Warning)`
  path {
    fill: ${({ theme }) => theme.text.modalTitle2};
  }
  align-self: center;
`;
Warning.displayName = 'Warning';

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  font-size: 21.5px;
  margin-left: 13px;
`;
Title.displayName = 'Title';

export const ModalBody = styled.div`
  text-align: left;
`;
export const BodyText = styled.div`
  color: ${colors.grey19};
  font-size: 12.5px;
  font-weight: 300;
  display: inline-block;
  text-align: left;
`;
BodyText.displayName = 'BodyText';

export const CountingRow = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.text.sideModaLabel};
  display: flex;
  font-size: 12.5px;
  gap: 8px;
  margin-top: 14px;
`;
CountingRow.displayName = 'CountingRow';

export const ImpactSummary = styled.div`
  border-top: 1px solid ${colors.grey14};
  margin-top: 18px;
  max-height: 220px;
  overflow-y: auto;
  padding-top: 14px;
`;
ImpactSummary.displayName = 'ImpactSummary';

export const ImpactSection = styled.div`
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;
ImpactSection.displayName = 'ImpactSection';

export const ImpactSectionTitle = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-size: 12.5px;
  font-weight: 600;
  margin-bottom: 8px;
`;
ImpactSectionTitle.displayName = 'ImpactSectionTitle';

export const ImpactList = styled.div`
  display: grid;
  gap: 6px;
`;
ImpactList.displayName = 'ImpactList';

export const ImpactItem = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
`;
ImpactItem.displayName = 'ImpactItem';

export const ImpactName = styled.div`
  color: ${colors.grey19};
  font-size: 12.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
ImpactName.displayName = 'ImpactName';

export const ImpactCount = styled.div`
  color: ${({ theme }) => theme.text.sideModaLabel};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;
ImpactCount.displayName = 'ImpactCount';

export const BoldText = styled.span`
  color: ${({ theme }) => theme.text.sideModaLabel};
  font-size: 12.5px;
  font-weight: 600;
  display: inline-block;
  text-align: left;
`;
BodyText.displayName = 'BodyText';

export const ButtonsContainer = styled.div`
display: flex;
justify-content: flex-end;
margin-top: 34px;
`;
ButtonsContainer.displayName = 'ButtonsContainer';

export const ConfirmButton = styled(Button)`
  position: relative;
  ${({ $isLoading }) => $isLoading && `
    color: transparent;
    pointer-events: none;
  `}
  ${({ $isLoading }) => $isLoading && spinner({
    background: 'transparent',
    diameter: '15px',
    foreground: colors.white
  })};
`;
ConfirmButton.displayName = 'ConfirmButton';

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 10px;
`;
CancelButton.displayName = 'CancelButton';
